export const DEBOUNCE_DELAY = 500

export const COMMON_ERROR_TITLE = '화면을 불러오지 못했어요'

export const COMMON_UPDATE_ERROR_TITLE = '업데이트에 실패했어요'
export const COMMON_SYSTEM_ERROR_TITLE = '시스템에 문제가 발생했어요'
export const COMMON_ERROR_DESCRIPTION = '잠시 후 다시 시도해주세요.'
export const COMMON_ERROR_CONFIRM_BUTTON_TEXT = '확인'

export const PAYMENT_ERROR_TITLE = '결제 중 오류가 발생했어요'

export const REMEMBER_ME_COOKIE_NAME = 'remember-me'

// UI Layout Constants
export const BOTTOM_CTA_HEIGHT = 120
export const INFOBOX_TO_CTA_GAP = 20
